import { createSlice } from '@reduxjs/toolkit'

export const peopleSlice = createSlice({
  name: 'people',
  initialState: {},
  reducers: {}
})

export const reducer = peopleSlice.reducer
